import type {
  PlacementDetailsAllocatedJobShift,
  PlacementDetailsAppliedModification,
} from 'src/store/placementDetailsPageSlice/types';

// **** Types **** //

export interface ModificationListItem {
  modificationText: string;
  taskNames: string[];
}

/**
 * Convert a single or "list of" AllocatedJobShifts to a user readable list of modifications.
 */
export const allocatedJobShiftsToModificationDisplayList = (
  allocatedJobShifts: PlacementDetailsAllocatedJobShift | PlacementDetailsAllocatedJobShift[],
): ModificationListItem[] => {
  // Get the list of applied modifications
  const jobsShifts = Array.isArray(allocatedJobShifts) ? allocatedJobShifts : [allocatedJobShifts];
  const allAppliedMods = jobsShifts.flatMap((ajs) => ajs.appliedModifications);
  // Group the modifications by name and free form text
  const groupedMods = new Map<string, PlacementDetailsAppliedModification[]>();
  allAppliedMods.forEach((appliedMod) => {
    const { modificationName, freeFormText } = appliedMod;
    const fft = freeFormText ? ': ' + freeFormText : '';
    const key = `${modificationName}${fft}`;
    const group = groupedMods.get(key) ?? [];
    group.push(appliedMod);
    groupedMods.set(key, group);
  });
  // Setup the result
  return Array.from(groupedMods.entries())
    .map(([key, appliedMods]) => ({
      modificationText: key,
      taskNames: [...new Set(appliedMods.map((am) => am.taskName))].sort((a, b) => a.localeCompare(b)),
    }))
    .sort((a, b) => a.modificationText.localeCompare(b.modificationText));
};
